import { createAnatomy } from '@ark-ui/react/anatomy';
import { dialogAnatomy as dialogAnatomyBase } from '@ark-ui/react/dialog';
import { fieldAnatomy as fieldAnatomyBase } from '@ark-ui/react/field';
import { radioGroupAnatomy as radioGroupAnatomyBase } from '@ark-ui/react/radio-group';

// Chakra's anatomy barrel imports every Ark component. The recipes this app
// actually renders only need these four, so production builds alias the
// barrel here and leave the rest out of the initial graph.
export const dialogAnatomy = dialogAnatomyBase.extendWith(
  'header',
  'body',
  'footer',
  'backdrop',
);
export const fieldAnatomy = fieldAnatomyBase.extendWith('requiredIndicator');
export const radioGroupAnatomy = radioGroupAnatomyBase.extendWith(
  'itemAddon',
  'itemIndicator',
);
export const toastAnatomy = createAnatomy('toast').parts(
  'root',
  'title',
  'description',
  'indicator',
  'closeTrigger',
  'actionTrigger',
);
